import { Loading } from '@components/common/Loading/Loading';
import { Secured } from '@components/Secured/Secured';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import {
  ARCHIVE,
  CONTROL,
  PROTOCOLS,
  REGISTRY,
  TASK,
  VACCIANTION,
} from '@/constants/routes';
import { VaccinationArchive } from '@/pages/Vaccination/components/archive/VaccinationArchive';
import { VaccinationControl } from '@/pages/Vaccination/components/control/VaccinationControl';
import { VaccinationProtocols } from '@/pages/Vaccination/components/protocols/VaccinationProtocols';
import { VaccinationRegistryArchive } from '@/pages/Vaccination/components/registry/archive/VaccinationRegistryArchive';
import { VaccinationRegistryCard } from '@/pages/Vaccination/components/registry/card/VaccinationRegistryCard';
import { VaccinationRegistry } from '@/pages/Vaccination/components/registry/VaccinationRegistry';
import { VaccinationTask } from '@/pages/Vaccination/components/task/VaccinationTask';
import { vaccination } from '@/shared/security/permissions/vaccination';

const LazyVaccination = lazy(() =>
  import('./VaccinationPage').then((module) => ({
    default: module.VaccinationPage,
  })),
);

const baseRoute: RouteObject = {
  path: VACCIANTION,
  element: <Loading children={<LazyVaccination />} />,
  children: [],
};

const vaccinationRoutes = [
  {
    path: VACCIANTION + REGISTRY,
    element: <VaccinationRegistry />,
  },
  {
    path: VACCIANTION + REGISTRY + '/:id',
    element: <VaccinationRegistryCard />,
  },
  {
    path: VACCIANTION + REGISTRY + ARCHIVE,
    element: <VaccinationRegistryArchive />,
  },
  {
    path: VACCIANTION + PROTOCOLS,
    element: <VaccinationProtocols />,
  },
  {
    path: VACCIANTION + CONTROL,
    element: (
      <Secured security={{ permissions: vaccination.control.viewMonitoring }}>
        <VaccinationControl />
      </Secured>
    ),
  },
  {
    path: VACCIANTION + CONTROL + ARCHIVE,
    element: (
      <Secured security={{ permissions: vaccination.task.viewArchive }}>
        <VaccinationArchive />
      </Secured>
    ),
  },
  {
    path: VACCIANTION + TASK,
    element: (
      <Secured security={{ permissions: vaccination.task.view }}>
        <VaccinationTask />
      </Secured>
    ),
  },
  {
    path: VACCIANTION + TASK + ARCHIVE,
    element: (
      <Secured security={{ permissions: vaccination.task.viewArchive }}>
        <VaccinationArchive />
      </Secured>
    ),
  },
];

baseRoute.children = [...vaccinationRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const VaccinationRoutes = routes;
